import React from "react";
import { Input } from "antd";

function InputField({
  label,
  id,
  extra,
  type = "text",
  placeholder,
  variant,
  state,
  disabled,
  onChange,
  value,
  name,
  icon,
  ...rest
}) {
  const inputClass = `mt-2 flex h-10 w-full items-center justify-center border-gray-600 rounded-xl border bg-white/0 p-3 text-sm ${
    disabled
      ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
      : state === "error"
      ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
      : state === "success"
      ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
      : "border-gray-50 dark:!border-white/10 dark:text-white dark:placeholder:!text-gray-300"
  }`;

  return (
    <div className={extra}>
      {(label || icon) && (
        <label
          htmlFor={id}
          className={`flex gap-1 items-center text-sm text-slate-900 dark:text-white ${
            variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-medium"
          }`}
        >
        {icon}{label}
        </label>
      )}

      {type === "password" ? (
        <Input.Password
          id={id}
          name={name}
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          visibilityToggle={true}
          onChange={onChange}
          className={inputClass}
          {...rest}
        />
      ) : (
        <Input
          id={id}
          name={name}
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          type={type}
          onChange={onChange}
          className={inputClass}
          {...rest}
        />
      )}
    </div>
  );
}

export default InputField;
